// lib/workspaceImportsInFlight.ts
// Drops in flight per workspace, across addFilesAsLayers calls: two overlapping drops share one
// workspace flag, and the first to finish must not take the second's feedback down with it.
const inFlight = new Map<string, number>();

export const holdWorkspaceImport = (workspaceId: string) => {
  inFlight.set(workspaceId, (inFlight.get(workspaceId) ?? 0) + 1);
};

/** Returns true when the last in-flight drop into this workspace has finished. */
export const releaseWorkspaceImport = (workspaceId: string): boolean => {
  const remaining = (inFlight.get(workspaceId) ?? 1) - 1;
  if (remaining > 0) {
    inFlight.set(workspaceId, remaining);
    return false;
  }
  inFlight.delete(workspaceId);
  return true;
};
